// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Таблица
 */
.Table_table__iHjPY {
    position: relative;
    font-size: 0.8em;
    font-family: 'Roboto', sans-serif;
    overflow: auto;
    scrollbar-gutter: stable;
    scrollbar-color: #666 #e6e6e6;
    white-space: nowrap;
    width: 100vw;
    height: calc(var(--tg-viewport-stable-height, 100vh) - var(--schedule-bottom-safe-area));
    display: flex;
    align-items: stretch;
    background: #fff;
}

.Table_table__iHjPY::-webkit-scrollbar {
    width: 14px;
    height: 14px;
}

.Table_table__iHjPY::-webkit-scrollbar-track {
    background: #e6e6e6;
}

.Table_table__iHjPY::-webkit-scrollbar-thumb {
    background: #666;
    border: 3px solid #e6e6e6;
    border-radius: 8px;
}

.Table_table__iHjPY::-webkit-scrollbar-thumb:hover {
    background: #444;
}
`, "",{"version":3,"sources":["webpack://./src/components/table/Table.module.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,cAAc;IACd,wBAAwB;IACxB,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,wFAAwF;IACxF,aAAa;IACb,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["/**\n * Таблица\n */\n.table {\n    position: relative;\n    font-size: 0.8em;\n    font-family: 'Roboto', sans-serif;\n    overflow: auto;\n    scrollbar-gutter: stable;\n    scrollbar-color: #666 #e6e6e6;\n    white-space: nowrap;\n    width: 100vw;\n    height: calc(var(--tg-viewport-stable-height, 100vh) - var(--schedule-bottom-safe-area));\n    display: flex;\n    align-items: stretch;\n    background: #fff;\n}\n\n.table::-webkit-scrollbar {\n    width: 14px;\n    height: 14px;\n}\n\n.table::-webkit-scrollbar-track {\n    background: #e6e6e6;\n}\n\n.table::-webkit-scrollbar-thumb {\n    background: #666;\n    border: 3px solid #e6e6e6;\n    border-radius: 8px;\n}\n\n.table::-webkit-scrollbar-thumb:hover {\n    background: #444;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `Table_table__iHjPY`
};
export default ___CSS_LOADER_EXPORT___;
